import { render } from "./TaskLogicalMemory.vue?vue&type=template&id=d5d9e7ce"
import script from "./TaskLogicalMemory.vue?vue&type=script&lang=js"
export * from "./TaskLogicalMemory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__